/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {ScheduleLogListApiResult, ScheduleLogListApiResultFromJSON,} from '../models';

export interface ScheduleHistoryRequest {
    name?: string;
}

/**
 * ScheduleApi - interface
 *
 * @export
 * @interface ScheduleApiInterface
 */
export interface ScheduleApiInterface {
    /**
     *
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApiInterface
     */
    scheduleHistoryRaw(requestParameters: ScheduleHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ScheduleLogListApiResult>>;

    /**
     */
    scheduleHistory(name?: string, initOverrides?: RequestInit): Promise<ScheduleLogListApiResult>;

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApiInterface
     */
    schedulesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ScheduleLogListApiResult>>;

    /**
     */
    schedules(initOverrides?: RequestInit): Promise<ScheduleLogListApiResult>;

}

/**
 *
 */
export class ScheduleApi extends runtime.BaseAPI implements ScheduleApiInterface {

    /**
     */
    async scheduleHistoryRaw(requestParameters: ScheduleHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ScheduleLogListApiResult>> {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ScheduleHistory`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleLogListApiResultFromJSON(jsonValue));
    }

    /**
     */
    async scheduleHistory(name?: string, initOverrides?: RequestInit): Promise<ScheduleLogListApiResult> {
        const response = await this.scheduleHistoryRaw({name: name}, initOverrides);
        return await response.value();
    }

    /**
     */
    async schedulesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ScheduleLogListApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Schedules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleLogListApiResultFromJSON(jsonValue));
    }

    /**
     */
    async schedules(initOverrides?: RequestInit): Promise<ScheduleLogListApiResult> {
        const response = await this.schedulesRaw(initOverrides);
        return await response.value();
    }

}
